<template>
  <div>
    <common-dialog ref="dialog" width="650px" show-save-button unit="框管理" edit-title id-key="MaintenanceId"
      :data="data" :line-form="true" form-label-width="85px" :form-rules="rules" :save-func="api.save"
      @opened="onOpened" @create-opened="onCreateOpened" @edit-opened="onEditOpened" @closed="onClosed"
      @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="12" v-if="data.FrameNo">
            <el-form-item label="框编号" prop="FrameNo">
              <span>{{ data.FrameNo }}</span>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status" disabled>
                <el-radio :label="1">已用</el-radio>
                <el-radio :label="0">未用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="序号" prop="Sn" class="notBottom">
              <el-input v-model="data.Sn" placeholder="请输入序号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="框名" prop="FrameName" class="notBottom">
              <el-input v-model="data.FrameName" placeholder="请输入框名"/>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="存货" prop="ProductId" class="notBottom"> -->
              <!-- <account-select 
                v-model="data.ProductName" 
                :source="DAccount" 
                :pageSize="pageParams.pageSize" 
                :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal" 
                :pageType="true" 
                @select="onSelect($event)" 
                @inputText="inputText" 
                @click.native="resetFun()" 
                @currentPage="currentPage($event)" 
              /> -->
              <!-- <span>{{ data.ProductName }}</span>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item label="数量" prop="Quantity" class="notBottom">
              <el-input v-model="data.Quantity" placeholder="请输入数量"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库" label-width="85px" prop="WarehouseId"  class="notBottom">
              <el-select filterable v-model="data.WarehouseId" placeholder="请选择">
                <el-option v-for="(item) in WarehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
              </el-select>
             </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark"  class="notBottom">
              <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import accountSelect from "@/components/business/sales/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    accountSelect
  },
  data() {
    return {
      data: {
        FrameId:null,
        FrameNo:null,
        Status:0,
        Sn:null,
        Remark:null,
        ProductId:null,
        Quantity:null,
        WarehouseId:null,
        FrameName:null,
        ProductName:null
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/pr/frame").default,
      dpApi: require("@/api/ent/dp").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      pdApi: require("@/api/ba/product").default,
      code_api: require("@/api/sy/serialCode").default,
      showList: [],
      empType: null,
      rules: {
        Sn: [{ required: true, message: "序号不能为空" }],
        FrameName: [{ required: true, message: "框名不能为空" }],
      },
      DpTreeData: [],
      DpProps: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      WarehouseList: [],
      DAccount: [],
      tableColorShow: true,
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
      
      this.warehouseApi.list({ Status: 1 }).then((res) => {
        if (res.Code === 0) {
          this.WarehouseList = res.Data;
        }
          console.log(this.WarehouseList);
      });

    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened() {
      this.dpApi.list({}).then(res => this.DpTreeData = this.$commonJs.toTreeData(res.Data, 'DpId'))

      this.code_api.previewNo("框").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.data.FrameNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取地区类别编号失败");
        }
      });

      
    },
    onEditOpened(data) {
      this.api.info(data.MaintenanceId).then(res => {
        if (res.Code === 0) {
          this.data = { ...res.Data }
          this.dpApi.list({}).then((res) => {
            if (res.Code === 0) {
              this.DpTreeData = this.$commonJs.toTreeData(res.Data, 'DpId')
              this.$refs.dpTreeSelect.setData(this.data.DpId);
            }
          })
        }
      })

    },
    onClosed() {
      this.showList = [];
    },
    // 选择存货名称
    onSelect(e) {
      this.data.ProductId = e.ProductId;
      this.data.ProductName = e.ProductName;
    },
    // 选择部门
    onSelectDp(e) {
      this.data.DpId = e[0];
      this.data.DpName = e[1];

    },
    inputText(text) {
      this.pdApi.list({
        pageIndex: 1,
        pageSize: 7,
        ProductName: text,
        Status: 1,
      })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;

      let param = { pageIndex: 1, pageSize: 7, Status: 1}

      this.pdApi.list(param).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count;
        }
      });

    },
    currentPage({ val, text1 }) {
      console.log(val,text1);
      this.pageParams.pageIndex = val;

      let param = {  pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }

      this.pdApi.list(param).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
